<template>
	<div>
		<div class="part">
			<div class="company-wrap">
				<div class="company">
					<div class="company-logo">
						<img :src="company.logoFileUrl" />
					</div>
					<div class="company-txt">
						<span class="company-name">{{company.companyName}}</span>
						<span class="system-name">大学生活动管理系统</span>
						<span class="number">{{company.vacationNum}}次</span>
						<span class="company-btn"><router-link to="/admin/addActivity">发起新活动</router-link></span>
					</div>
				</div>
			</div>
			<div class="data-wrap">
				<div class="data">
					<div class="data-top">
						<ul>
							<li>
								<span class="icon"></span>
								<span class="status">已报名</span>
								<div class="number">
									{{model.enrollNum}}<span>人</span>
								</div>
							</li>
							<li>
								<span class="icon"></span>
								<span class="status">已参加</span>
								<div class="number">
									{{model.joinNum}}<span>人</span>
								</div>
							</li>
							<li>
								<span class="icon"></span>
								<span class="status">完成签收</span>
								<div class="number">
									{{model.finishNum}}<span>人</span>
								</div>
							</li>
							<li>
								<span class="icon"></span>
								<span class="status">发布动态</span>
								<div class="number">
									{{model.feedNum}}<span>条</span>
								</div>
							</li>
						</ul>
					</div>
					<div class="data-bom">
						<div class="data-bom-list" @click="toSchoolStatistics">
							<div class="data-bom-txt">
								<span class="icon"></span>
								<div class="data-bom-status">
									<span class="status-type">参加学校</span>
									<span class="status-tips">（入选者）</span>
								</div>
								<div class="number">
									{{model.joinSchool}}<span>所</span>
								</div>
							</div>
						</div>
						<div class="data-bom-list" @click="toArea(0)">
							<div class="data-bom-txt">
								<span class="icon"></span>
								<div class="data-bom-status">
									<span class="status-type">覆盖省</span>
									<span class="status-tips">（入选者）</span>
								</div>
								<div class="number">
									{{model.joinProvince}}<span>个</span>
								</div>
							</div>
						</div>
						<div class="data-bom-list" @click="toArea(1)">
							<div class="data-bom-txt">
								<span class="icon"></span>
								<div class="data-bom-status">
									<span class="status-type">覆盖市</span>
									<span class="status-tips">（入选者）</span>
								</div>
								<div class="number">
									{{model.joinCity}}<span>个</span>
								</div>
							</div>
						</div>
						<div class="data-bom-list" @click="toArea(2)">
							<div class="data-bom-txt">
								<span class="icon"></span>
								<div class="data-bom-status">
									<span class="status-type">覆盖区县</span>
									<span class="status-tips">（入选者）</span>
								</div>
								<div class="number">
									{{model.joinDistrict}}<span>个</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="part">
			<div class="banner-wrap">
				<div class="swiper-container banner">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in bannerList">
							<video :id="'my_player'+index" controls muted :src="item.videoUrl"></video>
						</div>
					</div>
					<!-- <div class="swiper-pagination"></div> -->
					<div class="swiper-button-prev"></div>
					<div class="swiper-button-next"></div>
				</div>
			</div>
			<div class="activity-wrap">
				<div class="activity">
					<Title title="已开展活动">
						<div class="title-more" slot="title-more">
							<router-link to="/admin/activityList">更多</router-link>
							<i class="el-icon-arrow-right"></i>
						</div>
					</Title>
					<ul class="list">
						<li v-for="(item,index) in activityListIndex" v-if="index<6">
							<div class="list-title">
								<router-link to="/admin/activityList">{{item.vacationName}}</router-link>
							</div>
							<div class="list-time">{{item.publishTime|datefmt('YYYY-MM-DD HH:mm:ss')}}</div>
							<div class="list-operate">
								<span v-if="item.csrUrl" class="list-report" @click="toCSRReport(item)">CSR报告</span>
								<span v-else class="list-report-gray" @click="toCSRReport(item)">CSR报告</span>
								<a v-if="item.voteFlag" href="javascript:;" @click="toSelection(item)">查看评选></a>
								<a v-else href="javascript:;" @click="toAddSelection(item)">发起评选</a>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--学校列表-->
		<div class="wrap">
			<div class="title-wrap">
				<h3>{{model&&model.selectVacation?model.selectVacation.vacationName:''}}</h3>
				<span @click="selectDialog">选看活动</span>
			</div>
			<ul class="list-wrap">
				<li>
					<div class="table-title">
						<div class="table-title-l">
							<img src="@/assets/table_icon_01.png" />
							<h3>学生热力榜</h3>
						</div>
						<div class="table-title-r">
							<router-link to="/admin/studentCollect">选人用人</router-link>
						</div>
					</div>
					<div class="tables">
						<el-table @row-click="showStudentDialog" size="mini" border :data="hotStudentList" style="width: 100%" :cell-style="cellStyle">
							<el-table-column type="index" width="38">
							</el-table-column>
							<el-table-column prop="userName" label="大学生">
							</el-table-column>
							<el-table-column prop="school" label="学校" width="170">
							</el-table-column>
							<el-table-column label="收藏人才" width="70">
								<template slot-scope="scope">
									<img v-if="scope.row.isLike==1" @click.stop="cancelCollectStu(scope.row.id)" class="collect-icon" src="../../../assets/collect_icon_02.png"/>
									<img v-else @click.stop="addCollectStu(scope.row.memberId)" class="collect-icon" src="../../../assets/collect_icon_01.png"/>
								</template>
							</el-table-column>
							<el-table-column prop="number" label="分数">
								<template slot="header" slot-scope="scope">
									<div class="list-more" @click="toStudent">更多<i class="el-icon-arrow-right"></i></div>
								</template>
							</el-table-column>
						</el-table>
					</div>

				</li>
				<li>
					<div class="table-title">
						<div class="table-title-l">
							<img src="@/assets/table_icon_02.png" />
							<h3>高校热力榜</h3>
						</div>
					</div>
					<div class="tables">
						<el-table @row-click="showSchoolStu" size="mini" border :data="hotSchoolList" style="width: 100%" :cell-style="cellStyle">
							<el-table-column type="index">
							</el-table-column>
							<el-table-column prop="school" label="学校">
							</el-table-column>
							<el-table-column prop="number" label="人数" width="80">
								<template slot="header" slot-scope="scope">
									<div class="list-more" @click="toSchool">更多<i class="el-icon-arrow-right"></i></div>
								</template>
							</el-table-column>
						</el-table>
						<!-- <table>
							<thead>
								<tr>
									<th></th>
									<th>学校</th>
									<th width="60">
										<a href="#" class="more-link">更多</a>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,index) in hotSchoolList" @click="dialogSchool=true">
									<td>
										<span class="sort-index">{{index+1}}</span>
									</td>
									<td>{{item.school}}</td>
									<td>{{item.number}}</td>
								</tr>
							</tbody>
						</table> -->
					</div>

				</li>
			</ul>
		</div>
		<!--选择活动弹窗-->
		<el-dialog title="选择活动" :visible.sync="dialogVisible" width="70%" @click="dialogVisible=false">
			<el-form :inline="true" class="activity-form-wrap">
				<el-form-item label="活动名称">
					<el-input v-model="vacationName" placeholder="请输入活动名称" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearchActivity">搜索</el-button>
					<el-button icon="el-icon-refresh" size="mini" @click="toResetActivity">重置</el-button>
				</el-form-item>
			</el-form>
			<el-table size="mini" border :data="activityList" style="width: 100%">
				<el-table-column prop="vacationName" label="活动名称" height="30">
				</el-table-column>
				<el-table-column prop="activityType" label="活动类型" width="140">
					<template slot-scope="scope">
						<span v-if="scope.row.activityType==0">包裹发放</span>
						<span v-else>最美推荐</span>
					</template>
				</el-table-column>
				<el-table-column prop="recruitNums" label="招募人数" width="100">
				</el-table-column>
				<el-table-column prop="recruitTime" label="报名时间">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="select-txt" @click="selectActivity(scope.row)">选择</span>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="activityTotal" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		</el-dialog>
		<!--报名表详情弹窗-->
		<el-dialog title="报名表详情" :visible.sync="dialogTable" width="50%" @click="dialogTable=false">
			<table class="dialog-table">
				<tr>
					<th>假期名称</th>
					<td>{{enrollModel.vacationName}}</td>
				</tr>
				<tr>
					<th>姓名</th>
					<td>{{enrollModel.userName}}</td>
				</tr>
				<tr>
					<th>学校</th>
					<td>{{enrollModel.school}}</td>
				</tr>
				<tr>
					<th>年级</th>
					<td>{{enrollModel.grade}}</td>
				</tr>
				<!-- <tr>
					<th>学生证</th>
					<td><img class="certificate" src="@/assets/login.png"/></td>
				</tr> -->
				<tr>
					<th>专业</th>
					<td>{{enrollModel.major}}</td>
				</tr>
				<tr>
					<th>省份名称</th>
					<td>{{enrollModel.provinceName}}</td>
				</tr>
				<tr>
					<th>城市名称</th>
					<td>{{enrollModel.cityName}}</td>
				</tr>
				<tr>
					<th>区县名称</th>
					<td>{{enrollModel.districtName}}</td>
				</tr>
				<tr>
					<th>详细地址</th>
					<td>{{enrollModel.returnAddress}}</td>
				</tr>
				<tr>
					<th>身份证号</th>
					<td>{{enrollModel.idCard}}</td>
				</tr>
				<tr>
					<th>电话</th>
					<td>{{enrollModel.showPhone}}</td>
				</tr>
				<tr>
					<th></th>
					<td class="title-more" @click="showFeed(enrollModel.memberId)">看TA的活动动态</td>
				</tr>
			</table>
		</el-dialog>
		<!--热力榜弹窗-->
		<el-dialog custom-class="dialog-scholl" title="热力榜-中国人民公安大学" :visible.sync="dialogSchool" width="40%" @click="dialogSchool=false">
			<h3>LG圆满假期 ｜ 第20季</h3>
			<div class="dialog-school-wrap">
				<p>仅显示该校已入选参加此活动者安排</p>
				<el-table :data="tableData" style="width: 100%">
					<el-table-column width="40">
						<template slot-scope="scope">
							<span class="sort-index">1</span>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="大学生" height="30">
					</el-table-column>
					<el-table-column prop="voteTime" label="积分">
					</el-table-column>
				</el-table>
			</div>

		</el-dialog>
		<!--学生动态弹窗-->
		<el-dialog title="TA的动态" :visible.sync="dialogFeed" width="60%" @click="closeFeed">
			<div class="dialog-school-wrap">
				<el-table @row-click="feedRowClick" size="mini" border :data="feedList" style="width: 100%" :cell-style="cellStyle">
					<el-table-column prop="title" label="标题" width="400">
					</el-table-column>
					<el-table-column label="动态类型">
						<template slot-scope="scope">
							<span v-if="scope.row.feedType==0">文字动态</span>
							<span v-if="scope.row.feedType==1">图片动态 <i class="preview-btn">查看</i></span>
							<span v-if="scope.row.feedType==2">视频动态 <i class="preview-btn">查看</i></span>
						</template>
					</el-table-column>
					<el-table-column label="发布时间">
						<template slot-scope="scope">
							<span>{{scope.row.addTime | datefmt2('YYYY-MM-DD HH:mm')}}</span>
						</template>
					</el-table-column>
				</el-table>
				<Pagination :total="feedTotal" :pageSize="feedPageSize" @pageChange="handleFeedChange"/>
			</div>
		
		</el-dialog>
		<!--视频预览-->
		<el-dialog title="视频预览" :visible.sync="videoDialog" width="50%" @close="handleClose('video')">
			<div class="video-wrap">
				<video ref="videoPreview" controls muted autoplay :src="feedDetailModel.fileUrl"></video>
			</div>
		</el-dialog>
		<!--动态图片预览-->
		<el-dialog title="图片预览" :visible.sync="imgDialog" width="50%" @close="handleClose('img')">
			<div class="picture-wrap">
				<div class="picture-list" v-for="item in feedDetailModel.attachList">
					<!-- <img :src="item.fileUrl"/> -->
					<el-image 
					    style="width: 100%; height: 100px;"
					    :src="item.fileUrl" 
					    :preview-src-list="attachList">
					  </el-image>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="school" :visible.sync="dialogStuTable" width="60%" @close="closeStuSchoolDialog">
			<el-table :data="hotStudentListDialog" size="mini" border style="width: 100%" :cell-style="cellStyle">
				<el-table-column prop="userName" label="姓名">
				</el-table-column>
				<el-table-column prop="number" label="分数">
				</el-table-column>
				<el-table-column prop="voteTime" label="收藏">
					<template slot-scope="scope">
						<img v-if="scope.row.isLike==1" @click.stop="cancelCollectStu2(scope.row.id)" class="collect-icon" src="../../../assets/collect_icon_02.png"/>
						<img v-else @click.stop="addCollectStu2(scope.row.id)" class="collect-icon" src="../../../assets/collect_icon_01.png"/>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="stuDialogTotal" :pageSize="stuDialogPageSize" @pageChange="handleCurrentChange3"/>
		</el-dialog>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.css'
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Admin',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				companyId:'',
				model: {},
				company: {},
				activityList: [],
				activityListIndex: [],
				vacationId: '',
				hotStudentList: [],
				hotSchoolList: [],
				bannerList: [],
				pageSize:10,
				pageNum: 1,
				activityTotal: 0,
				dialogVisible: false,
				dialogTable: false,
				dialogSchool: false,
				auditStatus: '',
				enrollModel: {},
				feedList: [],
				dialogFeed: false,
				feedPageNum: 1,
				feedPageSize: 10,
				feedTotal: 0,
				feedUserId: '',
				vacationName: '',
				feedDetailModel: {},
				videoDialog: false,
				imgDialog: false,
				attachList: [],
				hotStudentListDialog: [],
				stuDialogPageNum: 1,
				stuDialogPageSize: 10,
				stuDialogTotal: 0,
				dialogStuTable: false,
				schoolId: '',
				school: '',
				tableData: [{
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布'
				}, {
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布'
				}, {
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布'
				}, {
					name: '圆满假期第一期',
					voteTime: '2016-05-02',
					username: '王小虎',
					publicStatus: '已发布'
				}]
			}
		},
		created() {
			this.companyId = localStorage.getItem('companyId')
			setTimeout(() => {
				this.initSwiper()
			}, 1000)
			this.getHomeData()
			this.getBannerList()
			// this.getHotStudentList()
			// this.getHotSchoolList()
		},
		mounted() {

		},
		methods: {
			//获取首页数据
			async getHomeData(){
				let param = {
					companyId: this.companyId
				}
				ajaxParam(param)
				const res = await post('admin/index/info', qs.stringify(param))
				console.log(res)
				if(res.data.code==200){
					let model = res.data.entity
					this.model = model
					this.company = model.company
					this.vacationId=model.selectVacation.vacationId
					this.model.selectVacation.vacationName = model.selectVacation.vacationName
					this.activityListIndex = model.vacationList
					this.getHotStudentList()
					this.getHotSchoolList()
				}
			},
			//获取热力学生榜
			async getHotStudentList(){
				let param = {
					startCompanyId: this.companyId,
					vacationId: this.vacationId,
					memberId: localStorage.getItem('userId')||'',
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/index/hotStudentList', qs.stringify(param))
				if (res.data.code == 200) {
					this.hotStudentList = res.data.page.items
				}
			},
			//获取某校热力学生榜
			async getHotStudentList2(id, school){
				let param = {
					startCompanyId: this.companyId,
					vacationId: this.vacationId,
					schoolId: id,
					school: school,
					memberId: localStorage.getItem('userId')||'',
					pageNum: this.stuDialogPageNum,
					pageSize: this.stuDialogPageSize
				}
				ajaxParam(param)
				const res = await post('admin/index/hotStudentList', qs.stringify(param))
				if (res.data.code == 200) {
					this.hotStudentListDialog = res.data.page.items
					this.stuDialogTotal = res.data.page.count
				}
			},
			showSchoolStu(row){
				console.log(row)
				this.dialogStuTable = true
				this.schoolId = row.schoolId
				this.school = row.school
				this.getHotStudentList2(row.schoolId,row.school)
			},
			closeStuSchoolDialog(){
				this.dialogStuTable = false
				this.hotStudentListDialog = []
				this.stuDialogPageNum = 1
				this.stuDialogTotal = 0
			},
			handleCurrentChange3(e){
				this.hotStudentListDialog = []
				this.stuDialogPageNum = e.number
				this.getHotStudentList2(this.schoolId,this.school)
			},
			//收藏大学生
			async addCollectStu2(id){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					likeId: id  //收藏的大学生id
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/save', qs.stringify(param))
				if (res.data.code == 200) {
					//收藏成功
					this.$message.success('收藏成功！')
					this.hotStudentListDialog.forEach(item=>{
						if(item.id==id) {
							item.isLike = '1'
						}
					})
				}
			},
			//取消收藏大学生
			async cancelCollectStu2(id){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					likeId: id  //收藏的大学生id
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/delete', qs.stringify(param))
				if (res.data.code == 200) {
					//取消收藏成功
					this.$message.success('取消收藏成功！')
					this.hotStudentListDialog.forEach(item=>{
						if(item.id==id) {
							item.isLike = '0'
						}
					})
				}
			},
			//获取热力学校榜
			async getHotSchoolList(){
				let param = {
					startCompanyId: this.companyId,
					vacationId: this.vacationId,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/index/hotSchoolList', qs.stringify(param))
				if (res.data.code == 200) {
					this.hotSchoolList = res.data.page.items
				}
			},
			selectDialog(){
				this.dialogVisible = true
				this.getActivityList()
			},
			toSearchActivity(){
				this.getActivityList()
			},
			toResetActivity(){
				this.vacationName = ''
				this.pageNum = 1
				this.activityTotal = 0
				this.activityList = []
				this.getActivityList()
			},
			// 确认选择活动
			selectActivity(row){
				this.vacationId = row.id
				this.model.selectVacation.vacationName = row.vacationName
				this.auditStatus = ''
				this.dialogVisible = false
				this.hotStudentList = []
				this.hotSchoolList = []
				this.getHotSchoolList()
				this.getHotStudentList()
			},
			//获取活动列表  新加只显示通过审核并发布的参数
			async getActivityList(){
				let param = {
					vacationName: this.vacationName,
					startCompanyId: this.companyId,
					auditStatus: 2,
					publishStatus: 1,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/vacation/list', qs.stringify(param))
				if (res.data.code == 200) {
					this.activityList = res.data.page.items
					this.activityTotal = res.data.page.count
				}
			},
			//获取轮播
			async getBannerList(){
				let param = {
					startCompanyId: this.companyId
				}
				ajaxParam(param)
				const res = await post('admin/index/videoList', qs.stringify(param))
				if (res.data.code == 200) {
					this.bannerList = res.data.page.items
				}
			},
			initSwiper() {
				new Swiper(".banner", {
					//autoplay: 6000,
					//autoplayDisableOnInteraction: false,
					// 轮播效果,默认为平滑轮播
					effect: "slide",
					//pagination: '.swiper-pagination',
					prevButton:'.swiper-button-prev',
					nextButton:'.swiper-button-next',
					paginationClickable: true,
					onClick: ()=>{
						if (this.bannerList.length > 0) {
							this.bannerList.forEach((item, index) => {
							console.log(index)
							document.getElementById("my_player" + index).pause();
							})
						}
					}
				})
			},
			showSchoolDialog(e){
				console.log(e)
				this.dialogSchool = true
			},
			showStudentDialog(e){
				this.getEnrollDetail(e.id)
				this.dialogTable = true
			},
			//获取报名表详情
			async getEnrollDetail(id){
				let param = {
					id: id
				}
				ajaxParam(param)
				const res = await post('admin/enroll/detail', qs.stringify(param))
				if (res.data.code == 200) {
					this.enrollModel = res.data.entity
				}
			},
			//收藏大学生
			async addCollectStu(id){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					likeId: id  //收藏的大学生id
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/save', qs.stringify(param))
				if (res.data.code == 200) {
					//收藏成功
					this.$message.success('收藏成功！')
					this.hotStudentList.forEach(item=>{
						if(item.memberId==id) {
							item.isLike = '1'
						}
					})
				}
			},
			//取消收藏大学生
			async cancelCollectStu(id){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					likeId: id  //收藏的大学生id
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/delete', qs.stringify(param))
				if (res.data.code == 200) {
					//取消收藏成功
					this.$message.success('取消收藏成功！')
					this.hotStudentList.forEach(item=>{
						if(item.id==id) {
							item.isLike = '0'
						}
					})
				}
			},
			handleCurrentChange(e){
				this.activityList = []
				this.pageNum = e.number
				this.getActivityList()
			},
			toSelection(item){
				this.$router.push({
					path: '/admin/activity/activityVote?id='+item.id
				})
			},
			toAddSelection(item){
				this.$router.push({
					path: '/admin/addSelection?vacationId='+item.id
				})
			},
			toStudent(){
				this.$router.push({
					path: '/admin/studentHot?id='+this.vacationId
				})
			},
			toSchool(){
				this.$router.push({
					path: '/admin/schoolHot?id='+this.vacationId
				})
			},
			toSchoolStatistics(){
				this.$router.push({
					path: '/admin/statisticsArea2?type=3'
				})
			},
			toArea(index) {
				this.$router.push({
					path: '/admin/statisticsArea?type='+index
				})
			},
			toCSRReport(item){
        this.$router.push({
          path: '/admin/activity/report?id='+item.id
        })
			},
			cellStyle(){
				return "cursor:pointer;"
			},
			handleFeedChange(e){
				this.feedList = []
				this.feedPageNum = e.number
				this.getFeedList(this.feedUserId)
			},
			//关闭学生动态
			closeFeed(){
				this.dialogFeed=false
				this.feedUserId = ''
			},
			//
			showFeed(userId){
				this.dialogFeed = true
				this.feedUserId = userId
				this.getFeedList(userId)
			},
			//获取学生动态
			async getFeedList(userId) {
				let param = {
					vacationId: this.vacationId,
					userId: userId,
					pageNum: this.feedPageNum,
					pageSize: this.feedPageSize
				}
				ajaxParam(param)
				const res = await post('admin/feed/list', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					this.feedList = datalist
					this.feedTotal = res.data.page.count
				}
			},
			//动态视频预览
			toVideo(row){
				this.getFeedDetail(row)
				this.videoDialog = true
			},
			//动态图片预览
			toPicture(row){
				this.getFeedDetail(row)
				this.imgDialog = true
			},
			async getFeedDetail(row){
				let param = {
					id: row.id
				}
				ajaxParam(param)
				const res = await post('admin/feed/detail', qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res.data)
					let entity = res.data.entity
					this.feedDetailModel = entity
					if(entity.feedType ==1){
						entity.attachList.forEach(item=>{
							this.attachList.push(item.fileUrl)
						})
					}
				}
			},
			feedRowClick(row){
				if(row.feedType==1) {
					this.toPicture(row)
				} else if(row.feedType==2){
					this.toVideo(row)
				}
			},
			handleClose(type){
				if(type=='img'){
					this.imgDialog = false
				} else if(type=='video'){
					const videoPlayer = this.$refs.videoPreview;
					if (videoPlayer) {
						videoPlayer.pause(); // 暂停视频
					}
					this.videoDialog = false
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.part {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.company-wrap {
		width: 30%;
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-right: 20px;
		padding: 10px;
		box-sizing: border-box;

		.company {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 180px;
			background: #eb6b1b;
			border-radius: 5px;
			box-sizing: border-box;
			padding: 0 10px;

			.company-logo {
				width: 120px;
				height: 120px;
				background: #F5F6F8;
				padding: 10px;
				box-sizing: border-box;
				border-radius: 5px;

				img {
					width: 100px;
					width: 100px;
				}
			}

			.company-txt {
				display: flex;
				flex-direction: column;
				flex: 1;
				color: #fff;
				padding: 0 10px;

				span {
					margin-top: 7px;
				}

				.company-name {
					font-size: 18px;
					font-weight: bold;
				}

				.system-name {
					font-size: 12px;
				}

				.number {
					width: 38px;
					height: 20px;
					background: rgba(255, 255, 255, 0.1);
					border-radius: 4px;
					border: 1px solid #FFFFFF;
					text-align: center;
					line-height: 20px;
				}

				.company-btn {
					width: 108px;
					height: 28px;
					background: #FFFFFF;
					border-radius: 4px;
					text-align: center;
					line-height: 28px;
					color: #EB6B1B;
					a{
						color: #EB6B1B;
					}
				}
			}
		}
	}

	.data-wrap {
		flex: 1;
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		padding: 10px;
		box-sizing: border-box;

		.data {
			.icon {
				width: 16px;
				height: 4px;
				background: #EB6B1B;
			}

			.status {
				margin: 8px 0 10px;
				opacity: .7;
				font-size: 14px;
			}
			.data-bom-status{
				display: flex;
				margin: 8px 0 10px;
				align-items: center;
				opacity: .7;
				.status-type{
					font-size: 14px;
				}
				.status-tips{
					//color: #f55;
					font-size: 12px;
				}
			}

			.number {
				font-size: 18px;
				font-weight: bold;

				span {
					font-size: 12px;
					font-weight: normal;
				}
			}

			.data-top {
				height: 85px;
				background: #faf6f5;
				border-radius: 5px;

				ul {
					display: flex;
					justify-content: space-around;
					padding-top: 10px;

					li {
						display: flex;
						flex-direction: column;
						background: url('../../../assets/info_icon_01.png') no-repeat right bottom;
						background-size: 47px 46px;
						width: 23%;

					}
					li:nth-of-type(2){
						background: url('../../../assets/info_icon_02.png') no-repeat right bottom;
					}
					li:nth-of-type(3){
						background: url('../../../assets/info_icon_03.png') no-repeat right bottom;
					}
					li:nth-of-type(4){
						background: url('../../../assets/info_icon_04.png') no-repeat right bottom;
					}
				}
			}

			.data-bom {
				display: flex;
				justify-content: space-between;
				margin-top: 10px;

				.data-bom-list {
					width: 24%;
					height: 85px;
					background: linear-gradient(158deg, #FFDCC6 0%, #FFF1E0 100%);
					border-radius: 10px;
					margin-right: 1%;
					padding: 10px;
					display: flex;
					justify-content: space-between;
					align-items: flex-end;
					box-sizing: border-box;
					cursor: pointer;

					.data-bom-txt {
						display: flex;
						flex: 1;
						flex-direction: column;
						background: url('../../../assets/data_icon_01.png') no-repeat right bottom;
						background-size: 42px 42px;
					}

					img {
						width: 45px;
						height: 45px
					}
				}
				
				.data-bom-list:nth-of-type(2) .data-bom-txt{
					background: url('../../../assets/data_icon_02.png') no-repeat right bottom;
				}
				.data-bom-list:nth-of-type(3) .data-bom-txt{
					background: url('../../../assets/data_icon_03.png') no-repeat right bottom;
				}
				.data-bom-list:nth-of-type(4) .data-bom-txt{
					background: url('../../../assets/data_icon_04.png') no-repeat right bottom;
				}

				.data-bom-list:last-of-type {
					margin-right: 0;
				}
			}
		}
	}

	.banner-wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-right: 20px;
		padding: 10px;
		box-sizing: border-box;
		width: 50%;

		.banner {
			height: 372px;

			video {
				width: 100%;
				height: 100%;
			}
		}
	}

	.activity-wrap {
		flex: 1;
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		padding: 10px;

		.list {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-top: -10px;

			li {
				width: 48%;
				background: #faf6f5;
				border-radius: 5px;
				margin-top: 10px;
				padding: 10px;
				box-sizing: border-box;

				.list-title {
					font-weight: 500;
					font-size: 16px;
					color: #37383c;
					letter-spacing: 1.29px;
					line-height: 32px;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
					cursor:pointer
				}

				.list-time {
					height: 28px;
					color: #666;
					font-size: 12px;
					line-height: 28px;
				}

				.list-operate {
					display: flex;
					justify-content: space-between;
					font-size: 12px;

					a {
						color: #EB6B1B;
					}
				}
				.list-report-gray{
					color: #EB6B1B;
				}
			}
		}
	}

	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		padding: 10px;

		.title-wrap {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 15px;
			padding-top: 10px;

			h3 {
				font-size: 22px;
			}

			span {
				width: 80px;
				height: 26px;
				background: #EB6B1B;
				border-radius: 15px;
				margin-left: 10px;
				color: #fff;
				text-align: center;
				line-height: 26px;
				font-size: 13px;
				cursor: pointer;
			}
		}

		.list-wrap {
			display: flex;
			justify-content: space-between;

			li {
				width: 49%;
				//background: linear-gradient(180deg, #fed96c 10%, #fdfdf2 50%);
				background: url('../../../assets/table_bg_01.png') no-repeat left top;
				background-size: 100% 100%;
				border-radius: 10px;
				padding: 10px;
				box-sizing: border-box;

				.table-title {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 10px;

					.table-title-l {
						display: flex;
						align-items: center;

						img {
							width: 36px;
							height: 36px;
							margin-right: 10px;
						}

						h3 {
							font-weight: bold;
							font-size: 16px;
						}
					}

					.table-title-r {
						width: 80px;
						height: 26px;
						background: #FFFFFF;
						border-radius: 15px;
						color: #EB6B1B;
						text-align: center;
						line-height: 26px;
						font-size: 13px;
						cursor: pointer;
						a{
							color: #EB6B1B;
						}
					}
				}
				.list-more{
					color: #2A76CD;
					text-align: center;
					line-height: 26px;
					font-size: 12px;
					cursor: pointer;
					font-weight: normal;
					a {
						color: #2A76CD;
					}
				}
				.tables {
					background: #fff;
					padding: 10px;
					border-radius: 6px;

					table {
						width: 100%;

						th {
							background: #f5f6f8;
							padding: 10px;
							text-align: left;
						}

						td {
							padding: 5px;
							border-bottom: 1px solid #f6f7f9;
						}

						.collect-icon{
							display: block;
							width: 16px;
							height: 16px;
							margin-left: 10px;
						}
						.more-link{
							color: #2A76CD;
							font-weight: normal;
							font-size: 12px;
						}

					}
				}
			}

			li:last-of-type {
				background: url('../../../assets/table_bg_02.png') no-repeat left top;
				background-size: 100% 100%;
			}
		}
	}

	.list-report {
		color: #2A76CD;
		cursor: pointer;
		a {
			color: #2A76CD;
		}
	}

	/deep/ .el-dialog__header {
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #DBDCDC !important;
	}

	/deep/ .el-dialog__body {
		padding-top: 10px;
		.el-input__inner{
			height: 30px;
			line-height: 30px;
		}
		.el-button--primary{
			background: #EB6B1B;
			border-color: #EB6B1B;
		}
	}
	.select-txt{
		color: #EB6B1B;
		cursor: pointer;
	}
	.dialog-table{
		width: 100%;
		font-size: 12px;
		th{
			width: 130px;
			background: #F3F4F6;
		}
		th,td{
			padding: 8px 20px;
			border: 1px solid #DBDCDC
		}
		td .certificate{
			width: 130px;
		}
	}

	/deep/ .dialog-scholl{
		background: linear-gradient(180deg, #FFBE96 0%, #FFE1CD 23%, #FFF9EE 100%);
		border-radius: 10px;
		.el-dialog__header{
			border-bottom: 0!important;
			padding-bottom: 5px;
		}
		.el-dialog__body{
			padding-top: 0!important;
		}
		.dialog-school-wrap{
			background: #fff;
			border-radius: 10px;
			padding: 10px 20px 20px;
			margin-top: 10px;
			p{
				margin-bottom: 8px;
				font-size: 12px;
				opacity: .5;
			}
		}
	}
	.sort-index{
		display: block;
		width: 16px;
		height: 16x;
		background: linear-gradient(323deg, #979AA8 0%, #DCDFE4 100%);
		border-radius: 8px;
		color: #fff;
		text-align: center;
		line-height: 16px;
		font-size: 12px;
	}
	tbody tr:first-of-type .sort-index{
		background: linear-gradient(145deg, #FF8678 0%, #FE2D2D 100%);
	}
	tbody tr:nth-of-type(2) .sort-index{
		background: linear-gradient(323deg, #FF6601 0%, #FF9F64 100%);
	}
	tbody tr:nth-of-type(3) .sort-index{
		background: linear-gradient(323deg, #ED9A2B 0%, #FFCA68 100%);
	}
	/deep/ .el-table th.el-table__cell{
		background: #F5F6F8
	}
	/deep/ .el-table thead{
		color: #323233;
	}
	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}
	/deep/ .el-form-item{
		margin-bottom: 15px;
	}
	.title-more {
		color: #EB6B1B;
		cursor: pointer;
		font-size: 14px;
		font-weight: bold;
		a {
			color: #EB6B1B;
		}
	}
	.video-wrap{
		video{
			width: 100%;
			max-width: 100%;
			max-height: 400px;
		}
	}
	.picture-wrap{
		display: flex;
		flex-wrap: wrap;
		.picture-list{
			width: 31.3%;
			margin: 0 1% 5px;
		}
	}
	.preview-btn{
		color: #EB6B1B
	}
</style>
